/**
 * Project rich HTML to plain text for PDF, AI, summary, and length checks.
 */
import { isAllowedSitescopeAttachmentSrc } from './opportunityRichHtmlFields';

const IMG_TAG = /<img\b[^>]*>/gi;

function imagePlaceholderFromTag(tag: string): string {
  const altMatch = /\balt=(["'])(.*?)\1/i.exec(tag);
  const alt = altMatch?.[2]?.trim();
  if (alt) {
    return `[image: ${alt}]`;
  }
  const srcMatch = /\bsrc=(["'])(.*?)\1/i.exec(tag);
  const src = srcMatch?.[2]?.trim() ?? '';
  if (isAllowedSitescopeAttachmentSrc(src)) {
    return '[image]';
  }
  return '[image]';
}

/**
 * Strip markup while preserving readable structure and attachment placeholders.
 */
export function convertToPlainText(html: string): string {
  if (!html.trim()) {
    return '';
  }

  let working = html.replace(IMG_TAG, tag => imagePlaceholderFromTag(tag));

  working = working
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(td|th)>/gi, ' ')
    .replace(/<\/(p|div|li|h[1-6]|tr)>/gi, '\n')
    .replace(/<li[^>]*>/gi, '- ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  return working;
}
